module.exports = "pegasus/assets/blocks/column-4-theme3.png";